'use strict'

exports = module.exports
exports.PROTOCOL_ID = '/multistream/1.0.0'



//////////////////
// WEBPACK FOOTER
// ./~/multistream-select/src/constants.js
// module id = 290
// module chunks = 0